import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  Ticks,
  scales,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import React, { useContext, useEffect, useRef } from "react";


ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels,
  ArcElement
);
export default function BarChart({ data, title, ref }) {
  let dados = data;
  dados = dados?.filter(function (el) {
    return el != null;
  });
  let labels = dados?.map((row) => row.name);

  const chartRef3 = useRef(null);


  let rows = dados?.map((row) => row.val);
  rows?.map((item, index) => {
    rows[index] = item.replace("R$", "").replaceAll(".", "").replace(",", ".");
  });
  const config = {
    type: "bar",
    data: {
      labels: labels,
      datasets: [
        {
          lable: "teste",
          data: rows,
          backgroundColor: [
            "#2c4992",
            "#e2746f",
            "#00a7e1",
            "#ec1c24",
            "#9e5fdf",
          ],
          // borderWidth: 1,
        },
      ],
    },
  };
  const options = {
    layout: {
      width: "100%",
      padding: {
        top: 20,
        left: 0,
        right: 0,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        display: false,
        grid: {
          display: false,
        }
      },
      x: {
        display: true,
        grid: {
          display: false,
        },
        ticks: {
          color: "#000000",
          font: {
            weight: "bold",
            size: 11
          }
        }
      },
    },
    plugins: {
      customCanvasBackgroundColor: {
        color: 'white',
      },
      datalabels: {
        labels: {
          title: {
            color: "#000000",
            // backgroundColor: "#ffffff70",
            font: function (context) {
              var w = context.chart.width;
              return {
                size: 11,
                weight: "bold"
              };
            },
          },
        },
        formatter: function (item) {
          var parts = item.toString().split('.');
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          return "R$" + parts.join(",");
        },
        align: "top",
        anchor: "end",

      },
      title: {
        display: false,
        text: title,
        font: {
          size: 900,
        },
      },
      legend: {
        display: false,
      },
    },
  };




  return <Bar ref={chartRef3} data={config?.data} options={options} />;
}
